import { buttonActive, buttonHover } from './states';
/**
 * Styles that extend `buttonBase` to change the button's cosmetic appearance.
 * Accessed via `buttonVariant(key)(theme)`.
 *
 * For usage guidelines, see the README.
 */
const buttonVariant = (key) => ({ color }) => {
    const themedStyles = {
        primary: Object.assign(Object.assign({ color: color.goten[100], backgroundColor: color.piccolo[100] }, buttonHover({
            backgroundColor: color.piccolo[80],
        })), buttonActive({
            backgroundColor: color.piccolo[120],
            outline: 'none',
        })),
        secondary: Object.assign(Object.assign({ color: color.bulma[100], backgroundColor: color.hit[100] }, buttonHover({
            backgroundColor: color.hit[80],
        })), buttonActive({
            backgroundColor: color.hit[120],
            outline: 'none',
        })),
        tertiary: Object.assign(Object.assign({ color: color.bulma[100], backgroundColor: 'transparent', border: `1px solid ${color.bulma[100]}` }, buttonHover({
            backgroundColor: color.hit[80],
        })), buttonActive({
            backgroundColor: color.hit[120],
            outline: 'none',
        })),
        highlight: Object.assign(Object.assign({ color: color.goten[100], backgroundColor: color.whis[100] }, buttonHover({
            opacity: 0.9,
        })), buttonActive({
            opacity: 0.8,
            outline: 'none',
        })),
        default: Object.assign(Object.assign({ color: color.bulma[100], background: 'none' }, buttonHover({
            color: color.bulma[100],
        })), buttonActive({
            color: color.bulma[100],
            outline: 'none',
        })),
    };
    return themedStyles[key];
};
/**
 * buttonShadow
 *
 * Removes user-agent `:focus` styles and generates a box-shadow using the
 * color provided.
 */
export const buttonShadow = (color) => ({ space }) => ({
    outline: 'none',
    boxShadow: `0 0 ${space.default}px ${color}`,
});
export { buttonVariant };
export default { buttonVariant };
